import React from 'react'

import PropTypes from 'prop-types'
import {
  Typography,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { Controller, useFormContext } from 'react-hook-form'

import { BaseDialog, Select } from 'components'

import constants from 'constants/index'

const ExportFormatDialog = ({
  open,
  onClose,
  onConfirmExport,
  isLoadingExcel,
  currentReportVersion,
  alertMessage,
}) => {
  const { control, errors } = useFormContext()

  const onSubmit = (data) => onConfirmExport(data)

  return (
    <BaseDialog
      open={open}
      setOpen={onClose}
      title="Escolha o Formato do Relatório"
      dialogSize="sm"
      fullWidth
      closeButtonText="Cancelar"
      actionButtonText="Confirmar"
      actionButton={onSubmit}
    >
      <Grid container spacing={2}>
        {alertMessage && (
          <Grid item xs={12}>
            <Alert severity="info">{alertMessage}</Alert>
          </Grid>
        )}
        <Grid item xs={12}>
          <Controller
            as={
              <RadioGroup row>
                <FormControlLabel
                  value="pdf"
                  control={<Radio color="primary" />}
                  label="PDF"
                />
                <FormControlLabel
                  value="excel"
                  control={<Radio color="primary" />}
                  label={isLoadingExcel ? 'Exportando...' : 'Excel'}
                  disabled={isLoadingExcel}
                />
              </RadioGroup>
            }
            name="exportFormat"
            control={control}
          />
          {errors.exportFormat && (
            <Typography color="error">{errors.exportFormat.message}</Typography>
          )}
        </Grid>
        {currentReportVersion?.id && (
          <Grid item xs={12}>
            <Typography variant="body2">
              Selecione uma opção para prosseguir:
            </Typography>
            <Controller
              as={
                <Select
                  disabled={isLoadingExcel}
                  items={constants.reportVersions.VERSION_EXISTS_ACTION_OPTIONS}
                  fullWidth
                />
              }
              name="dataAction"
              control={control}
            />
            {errors.dataAction && (
              <Typography color="error">{errors.dataAction.message}</Typography>
            )}
          </Grid>
        )}
      </Grid>
    </BaseDialog>
  )
}

ExportFormatDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirmExport: PropTypes.func.isRequired,
  isLoadingExcel: PropTypes.bool,
  currentReportVersion: PropTypes.object,
  alertMessage: PropTypes.node,
}
ExportFormatDialog.defaultProps = {
  isLoadingExcel: false,
  currentReportVersion: null,
  alertMessage: null,
}

export default ExportFormatDialog
